import React from 'react';
import { Box, Container, Typography, Stack, Link } from '@mui/material';
import SocialLinks from '../Common/SocialLinks';
import { useSocialLinks } from '../../hooks/useSocialLinks';
import { theme, commonStyles } from '../../styles/theme';

const DashboardFooter = () => {
  const { socialLinks } = useSocialLinks();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'transparent',
        borderTop: `1px solid ${theme.colors.borderSubtle}`,
        py: 3,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2} alignItems="center">
          {/* Social Links */}
          <SocialLinks links={socialLinks} color="text.secondary" size="medium" spacing={1.5} />
          
          {/* Copyright */}
          <Typography variant="body2" color="text.secondary" align="center">
            © {currentYear} GraveForge — Advanced NFT Collection Generator. All rights reserved.
          </Typography>
          
          {/* Powered By */}
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" color="text.secondary">
              Powered by
            </Typography>
            <Link
              href="https://www.solanadeads.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                textDecoration: 'none',
                '&:hover': {
                  opacity: 0.8
                }
              }}
            >
              <Box
                component="img"
                src="https://bpzpmhytoyurlgptrpmm.supabase.co/storage/v1/object/public/system-assets/logos/sdlogo.png"
                alt="Solana Deads"
                sx={{
                  height: 24,
                  width: 'auto'
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 'bold',
                  color: 'text.primary'
                }}
              >
                Solana Deads
              </Typography>
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default DashboardFooter;
